import React from 'react';
import { StyledEditablePropertyItemContainer } from '../sideBarComponentsStyles';

interface SideBarEditablePropertyItemProps {
  item: {
    label: string;
    type: string;
    currentValue: string | number;
    placeholder?: string;
    disabled?: boolean;
    nameAndId?: string;
    onBlur?: any;
    onChange:
      | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
      | undefined;
  };
}

export const SideBarEditablePropertyItem = ({
  item
}: SideBarEditablePropertyItemProps) => {
  const switchInputToShow = (type: string, value: string | number) => {
    switch (type) {
      case 'inputText':
        return (
          <input
            type="text"
            className="input-text"
            placeholder={item.placeholder}
            value={value}
            onChange={item.onChange}
            id={item.nameAndId}
            onBlur={item.onBlur}
            name={item.nameAndId}
            disabled={item.disabled}
          />
        );
      case 'inputNumber':
        return (
          <input
            type="number"
            className="input-text"
            placeholder={item.placeholder}
            value={value}
            onChange={item.onChange}
            id={item.nameAndId}
            name={item.nameAndId}
            disabled={item.disabled}
          />
        );
      case 'inputPassword':
        return (
          <input
            type="password"
            className="input-text"
            placeholder={item.placeholder}
            value={value}
            id={item.nameAndId}
            name={item.nameAndId}
            onChange={item.onChange}
            disabled={item.disabled}
          />
        );
      default:
        return (
          <input
            type="text"
            className="input-text"
            placeholder={item.placeholder}
            value={value}
            id={item.nameAndId}
            name={item.nameAndId}
            onChange={item.onChange}
            disabled={item.disabled}
          />
        );
    }
  };
  return (
    <StyledEditablePropertyItemContainer>
      <div key={item.label}>
        <div className="label">{item.label}</div>
        {switchInputToShow(item.type, item.currentValue)}
      </div>
    </StyledEditablePropertyItemContainer>
  );
};
